import React from "react";
import { Link } from "react-router-dom";
import { API_BASE_URL } from "../../config"; // Importa la base de URL desde config.js

const SuperAdminMenu = () => {
  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-4xl mx-auto bg-white shadow-md rounded-lg p-6">
        <h1 className="text-2xl font-bold text-gray-800 mb-6">
          Menú Principal - Super Admin
        </h1>
        <nav>
          <ul className="space-y-4">
            <li>
              <Link
                to="/super-admin/dashboard"
                className="block w-full px-4 py-2 bg-blue-600 text-white text-center rounded-md hover:bg-blue-700 transition duration-300"
              >
                Dashboard General
              </Link>
            </li>
            <li>
              <Link
                to="/super-admin/clover-auth"
                className="block w-full px-4 py-2 bg-blue-600 text-white text-center rounded-md hover:bg-blue-700 transition duration-300"
              >
                Configuración Clover
              </Link>
            </li>
          </ul>
        </nav>
        <p className="mt-6 text-gray-500 text-center">
          Servido desde: <span className="text-gray-800 font-semibold">{API_BASE_URL}</span>
        </p>
      </div>
    </div>
  );
};

export default SuperAdminMenu;
